import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionHotelPolicyI18nHotelInfo } from "./hotel-info";

import type { HotelPolicyI18nCategoriesAndManagerStore } from "../../../store/categories";

type Props = {
	base: HotelPolicyI18nCategoriesAndManagerStore["base"];
};

export const QuestionHotelPolicyI18nBase = ({ base }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base} islandTitle={"施設の基本設定"}>
			<QuestionHotelPolicyI18nHotelInfo />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionHotelPolicyI18nBase.displayName = "QuestionHotelPolicyI18nBase";
